import React, { useEffect, useState ,useRef} from "react";
import {
  Box,
  HStack,
  VStack,
  Text,
  Center,
  ScrollView,
  Button,
  useToast,
  Stack,
  FormControl,
  Select,
  Heading,
  FlatList,
  Avatar,
  Spacer,
  Tooltip,
  Switch,
  Input,
  Icon,
  Image,
  Menu,
  Divider,
  StatusBar,
  Modal,
  Checkbox,
} from "native-base";
import { useNavigation } from "@react-navigation/native";
import { useSelector, useDispatch } from "react-redux";
import { GlobalConstants } from "../constants/constants";
import { GlobalStyles } from "../constants/styles";
import { StyleSheet } from "react-native";
import { Pressable } from "react-native";
import CitizenSettingsPage from "./settings/CitizenSettingsPage";
import BusinessSettingsPage from "./settings/BusinessSettingsPage";
import CityGovSettingsPage from "./settings/CityGovSettingsPage";
import ChamberOfCommerceSettingsPage from "./settings/ChamberOfCommerceSettingsPage";
import EventSettingsPage from "./settings/EventSettingsPage";
import SetUser from "../redux/user/SetUser";
import axios from "axios";
import ConfigureSettingsPopup from "../components/ConfigureSettingsPopup";
import AdvertiserSettingsPage from "./settings/AdvertiserSettingsPage";

function Settings() {
  const navigation = useNavigation();
  const dispatch = useDispatch();

  let user = useSelector((state) => state.user.user);

  axios.defaults.headers.common = {
    Authorization: `bearer ${user ? user.token : null}`,
  };

  const [session, setSession] = useState(user);
    ///// header here 

    const initialRef = useRef(null);
    const finalRef = useRef(null);
    const [modalVisible, setModalVisible] = useState(false);

  const updateIsNewUserFlag = async () => {
    try {
      const resp = await axios.post(
        `${GlobalConstants.townTicksBaseUrl}users/flag/new`,
        {}
      );
      if (resp.data.status) {
        let data = { ...session };
        dispatch(SetUser.action(null));
        data.is_new_user = false;
        dispatch(SetUser.action(data));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = React.useCallback(async (value) => {
    await updateIsNewUserFlag();
  }, []);
  const styles = StyleSheet.create({
    textWithShadow: {
      fontSize: 30,
      color: GlobalStyles.colors.mustard,
      fontFamily: GlobalStyles.text.fontFamily,
      textShadowColor: "#585858",
      textShadowOffset: { width: 1, height: 1 },
      textShadowRadius: 0,
    },
    textWithShadowMobile: {
      fontSize: 15,
      color: GlobalStyles.colors.mustard,
      fontFamily: GlobalStyles.text.fontFamily,
      textShadowColor: "#585858",
      textShadowOffset: { width: 1, height: 1 },
      textShadowRadius: 0,
    },
  });

  useEffect(async () => {}, []);

  return (
    <>
    {user &&
          user.user_category == GlobalConstants.userCategories.citizen.id  ? (
            <>
            {window?.innerWidth > 450 ? (
                          <>
                            <StatusBar bg="#3700B3" barStyle="light-content" />
                              <Center>
                                <Box safeAreaTop bg="white" />
                                <HStack
                                  bg="muted.100"
                                  px="1"
                                  py="3"
                                  justifyContent="space-between"
                                  alignItems="center"
                                  w="100%"
                                  // maxW="900"
                                >
                                  <Center w={[150, 150, 300]}>
                                    <Pressable
                                      onPress={() => {
                                        // window.location.reload();
                                        navigation.navigate("Home");
                                      }}
                                    >
                                      <HStack alignItems="center">
                                        <Image
                                          source={require("../../assets/tt_logo.png")}
                                          alt="Alternate Text"
                                          size="xs"
                                        />
                                        {window?.innerWidth > 780 ? (
                                          <>
                                            <Text style={styles.textWithShadow}>TownTicks</Text>
                                          </>
                                        ) : (
                                          <>
                                          <Text style={styles.textWithShadowMobile}>TownTicks</Text>
                                          </>
                                        )}
                                      </HStack>
                                    </Pressable>
                                  </Center>
                                  <Center w={[75, 350, 600]}>
                                    <Stack
                                      flexDirection={window?.innerWidth < 415 ? "column" : "row"}
                                      justifyContent="center"
                                    >
                                      {!user ? (
                                        <Button
                                          onPress={() => {
                                            changeColor("WhyTownTicks");
                                            navigation.navigate("WhyTownTicks");
                                          }}
                                          colorScheme="primary"
                                          size="md"
                                          variant="link"
                                        >
                                          <Text
                                            w={[75, 150, 150]}
                                            color={whyTownTicksColor}
                                            fontFamily={GlobalStyles.text.fontFamily}
                                            fontSize={"lg"}
                                            fontWeight="bold"
                                          >
                                            Why TownTicks?
                                          </Text>
                                        </Button>
                                      ) : (
                                        <>
                                        <VStack
                                            bg="#F5F5F5"
                                            px="1"
                                            py="3"
                                            justifyContent="space-between"
                                            alignItems="center"
                                            w="100%"
                                            // maxW="900"
                                          >
                                            {/* <Stack
                                              alignItems="center"
                                              flexDirection={window?.innerWidth < 415 ? "column" : "row"}
                                            > */}
                                              <Stack
                                                w={[350, 450, 600]}
                                                justifyContent="space-between"
                                                flexDirection={"row"}
                                              >
                                                <Button
                                                  // isDisabled={true}
                                                  size={"sm"}
                                                  variant={"solid"}
                                                  mt="2"
                                                  mx="1"
                                                  px="2"
                                                  bg={GlobalStyles.colors.sideButton}
                                                  // borderColor={cityGovBtnTextColor}
                                                  // borderWidth={1}
                                                  // borderRadius={10}
                                                  _hover={{ bg: GlobalStyles.colors.grey }} 
                                                  
                                                  onPress={() =>
                                                    navigation.navigate("CitizenMainPage", {
                                                      action: "cityGov",
                                                      payload: GlobalConstants.feedTypes.cityGovernment.id,
                                                    })
                                                  }
                                                >
                                                  <VStack alignItems="center" space={1}>  
                                                    <Image
                                                      source={require("../../assets/side-bar-icons/cityGov.png")}
                                                      alt="Openings Icon"
                                                      size="7"
                                                    />
                                                    <Text
                                                      fontSize="12px"
                                                      fontWeight="400"
                                                      fontFamily={GlobalStyles.text.fontFamily}
                                                      color={GlobalStyles.colors.blue}
                                                    >
                                                      City Gov
                                                    </Text>
                                                  </VStack>
                                                
                                                </Button>
                                                <Button
                                                  size={"sm"}
                                                  variant={"solid"}
                                                  mt="2"
                                                  mx="1"
                                                  px="2"
                                                  bg={GlobalStyles.colors.sideButton}
                                                  // borderColor={businessBtnTextColor}
                                                  // borderWidth={1}
                                                  // borderRadius={10}
                                                  _hover={{ bg: GlobalStyles.colors.grey }} 
                                              
                                                  onPress={() =>
                                                    navigation.navigate("CitizenMainPage", {
                                                      action: "business",
                                                      payload: GlobalConstants.feedTypes.business.id,
                                                    })
                                                  }
                                                >
                                                  <VStack alignItems="center" space={1}>  
                                                    <Image
                                                      source={require("../../assets/side-bar-icons/Busines.png")}
                                                      alt="Openings Icon"
                                                      size="7"
                                                    />
                                                    <Text
                                                      fontSize="12px"
                                                      fontWeight="400"
                                                      fontFamily={GlobalStyles.text.fontFamily}
                                                      color={GlobalStyles.colors.blue}
                                                    >
                                                      Business Updates
                                                    </Text>
                                                  </VStack>
                                                  
                                                </Button>
                                                <Button
                                                  // isDisabled={true}
                                                  size={"sm"}
                                                  variant={"solid"}
                                                  mt="2"
                                                  mx="1"
                                                  px="2"
                                                  bg={GlobalStyles.colors.sideButton}
                                                  // borderColor={eventsBtnTextColor}
                                                  // borderWidth={1}
                                                  // borderRadius={10}
                                                   _hover={{ bg: GlobalStyles.colors.grey }} 
                                                  
                                                   onPress={() =>
                                                    navigation.navigate("CitizenMainPage", {
                                                      action: "events",
                                                      payload: GlobalConstants.feedTypes.events.id,
                                                    })
                                                  }
                                                  // isDisabled={isEventsEnabled ? false : true}
                                                >
                                                  <VStack alignItems="center" space={1}>  
                                                    <Image
                                                      source={require("../../assets/side-bar-icons/events.png")}
                                                      alt="Openings Icon"
                                                      size="7"
                                                    />
                                                    <Text
                                                      fontSize="12px"
                                                      fontWeight="400"
                                                      fontFamily={GlobalStyles.text.fontFamily}
                                                      color={GlobalStyles.colors.blue}
                                                    >
                                                      Events
                                                    </Text>
                                                  </VStack>
                                                </Button>
                                                <Button
                                                  // isDisabled={true}
                                                  size="sm"
                                                  variant="solid"
                                                  mt="2"
                                                  mx="1"
                                                  px="3"
                                                  py="3"
                                                  bg={GlobalStyles.colors.sideButton}
                                                  // borderColor={openingsBtnTextColor}
                                                  // borderWidth={1}
                                                  // borderRadius={10}
                                                  _hover={{ bg: GlobalStyles.colors.grey }} 
                                                  onPress={() =>
                                                    navigation.navigate("CitizenMainPage", {
                                                      action: "openings",
                                                      payload: GlobalConstants.feedTypes.openings.id,
                                                    })
                                                  }
                                                  // isDisabled={!isOpeningsEnabled}
                                                >
                                                  <VStack alignItems="center" space={1}>  
                                                    <Image
                                                      source={require("../../assets/side-bar-icons/openings.png")}
                                                      alt="Openings Icon"
                                                      size="7"
                                                    />
                                                    <Text
                                                      fontSize="12px"
                                                      fontWeight="400"
                                                      fontFamily={GlobalStyles.text.fontFamily}
                                                      color={GlobalStyles.colors.blue}
                                                    >
                                                      Openings
                                                    </Text>
                                                  </VStack>
                                                </Button>
                                                <Button
                                                  // isDisabled={true}
                                                  size={"sm"}
                                                  variant={"solid"}
                                                  mt="2"
                                                  mx="1"
                                                  px="2"
                                                  bg={GlobalStyles.colors.sideButton}
                                                  // borderColor={dealsBtnTextColor}
                                                  // borderWidth={1}
                                                  // borderRadius={10}
                                                   _hover={{ bg: GlobalStyles.colors.grey }} 
                                                  
                                                   onPress={() =>
                                                    navigation.navigate("CitizenMainPage", {
                                                      action: "deals",
                                                      payload: GlobalConstants.feedTypes.deals.id,
                                                    })
                                                  }
                                                  // isDisabled={isDealsEnabled ? false : true}
                                                >
                                                  <VStack alignItems="center" space={1}>  
                                                    <Image
                                                        source={require("../../assets/side-bar-icons/deals.png")}
                                                        alt="Alternate Text"
                                                        size="7"
                                                      />
                                                    <Text
                                                      fontSize="12px"
                                                      fontWeight="400"
                                                      fontFamily={GlobalStyles.text.fontFamily}
                                                      color={GlobalStyles.colors.blue} >
                                                      Deals
                                                    </Text>
                                                  </VStack>
                                                  
                                                </Button>
                                                <Button
                                                  // isDisabled={true}
                                                  size={"sm"}
                                                  variant={"solid"}
                                                  mt="2"
                                                  mx="1"
                                                  px="2"
                                                  bg={GlobalStyles.colors.sideButton}
                                                  // borderColor={dealsBtnTextColor}
                                                  // borderWidth={1}
                                                  // borderRadius={10}
                                                  _hover={{ bg: GlobalStyles.colors.grey }} 
                                                  onPress={() =>
                                                    navigation.navigate("CitizenMainPage", {
                                                      action: "Products",
                                                      payload: GlobalConstants.feedTypes.ads.id,
                                                    })
                                                  }

                                                >
                                                  <VStack alignItems="center" space={1}>  
                                                    <Image
                                                        source={require("../../assets/product.png")}
                                                        alt="Alternate Text"
                                                        size="7"
                                                      />
                                                    <Text
                                                      fontSize="12px"
                                                      fontWeight="400"
                                                      fontFamily={GlobalStyles.text.fontFamily}
                                                      color={GlobalStyles.colors.blue} >
                                                      Products
                                                    </Text>
                                                  </VStack>
                                                  
                                                </Button>
                                                <Button
                                                  // isDisabled={true}
                                                  size={"sm"}
                                                  variant={"solid"}
                                                  mt="2"
                                                  mx="1"
                                                  px="2"
                                                  bg={GlobalStyles.colors.sideButton}
                                                  // borderColor={dealsBtnTextColor}
                                                  // borderWidth={1}
                                                  // borderRadius={10}
                                                  _hover={{ bg: GlobalStyles.colors.grey }} 
                                                  onPress={() =>
                                                    navigation.navigate("CitizenMainPage", {
                                                      action: "ads",
                                                      payload: GlobalConstants.feedTypes.ads.id,
                                                    })
                                                  }
                                                  // onPress={() => {
                                                  //   changeColor("Deals");
                                                  //   feedsFirstPage(GlobalConstants.feedTypes.deals.id);
                                                  // }}
                                                  // isDisabled={isDealsEnabled ? false : true}
                                                >
                                                  <VStack alignItems="center" space={1}>  
                                                    <Image
                                                        source={require("../../assets/side-bar-icons/Ads.png")}
                                                        alt="Alternate Text"
                                                        size="7"
                                                      />
                                                    <Text
                                                      fontSize="12px"
                                                      fontWeight="400"
                                                      fontFamily={GlobalStyles.text.fontFamily}
                                                      color={GlobalStyles.colors.blue} >
                                                      Ads
                                                    </Text>
                                                  </VStack>
                                                  
                                                </Button>
                                              </Stack>
                                              
                                            {/* </Stack> */}
                                        </VStack>
                                        </>
                                      )}
                                    </Stack>
                                  </Center>

                                  {/* for header icons */}

                                  
                                  <Center w={[75, 150, 300]}>
                                    <Stack
                                      flexDirection={window?.innerWidth < 415 ? "column" : "row"}
                                      justifyContent="center"
                                      mx={10}
                                    >
                                      {!user ? (
                                        <>
                                            <Button
                                            size="sm"
                                            variant={"solid"}
                                            px="3"
                                            bg={signInGuestColor}
                                            borderColor={signInGuestTextColor}
                                            borderWidth={2}
                                            onPress={() => {
                                              changeColor("SignInGuest");
                                              navigation.navigate("SignInGuest");
                                            }}
                                          >
                                            <Text fontWeight="bold" color={signInGuestTextColor}>
                                              Guest
                                            </Text>
                                          </Button>
                                          {/* <Button
                                            size="sm"
                                            variant={"solid"}
                                            px="3"
                                            bg={GlobalStyles.colors.blue}
                                            borderColor={GlobalStyles.colors.white}
                                            borderWidth={2}
                                            onPress={() => {
                                              setModalVisible(!modalVisible);
                                            }}
                                          >
                                            <Text fontWeight="bold" color={GlobalStyles.colors.white}>
                                              Contact Us
                                            </Text>
                                          </Button> */}
                                          <Button
                                            size="sm"
                                            variant={"solid"}
                                            px="3"
                                            bg={signUpColor}
                                            borderColor={signUpTextColor}
                                            borderWidth={2}
                                            onPress={() => {
                                              changeColor("SignUp");
                                              navigation.navigate("SignUp");
                                            }}
                                          >
                                            <Text fontWeight="bold" color={signUpTextColor}>
                                              Sign Up
                                            </Text>
                                          </Button>
                                          <Button
                                            size="sm"
                                            variant={"solid"}
                                            px="3"
                                            bg={signInColor}
                                            borderColor={signInTextColor}
                                            borderWidth={2}
                                            onPress={() => {
                                              changeColor("SignIn");
                                              navigation.navigate("SignIn");
                                            }}
                                          >
                                            <Text fontWeight="bold" color={signInTextColor}>
                                              Sign In
                                            </Text>
                                          </Button>
                                        </>
                                      ) : (
                                        <>
                                          <Menu
                                            w="190"
                                            placement={"bottom right"}
                                            trigger={(triggerProps) => {
                                              return (
                                                <Pressable
                                                  accessibilityLabel="More options menu"
                                                  {...triggerProps}
                                                >
                                                  <Image source={require("../../assets/side-bar-icons/gg_menu-grid-r.png")} alt="card-icon" size="40px"/>
                                                  {/* <HamburgerIcon size="md" mt={2} /> */}
                                                  {/* <Avatar
                                                    size="sm"
                                                    source={{
                                                      uri: GlobalConstants.notFoundImageUrl,
                                                    }}
                                                    bg={GlobalStyles.colors.blue}
                                                  >
                                                    {getAvatarChar(user.email)}
                                                  </Avatar> */}
                                                </Pressable>
                                              );
                                            }}
                                          >
                                            <Menu.Item isDisabled>
                                              <Text
                                                fontWeight="bold"
                                                fontFamily={GlobalStyles.text.fontFamily}
                                                color={GlobalStyles.colors.blue}
                                              >
                                                {user.profile ? user.profile.name : user.email}
                                              </Text>
                                            </Menu.Item>
                                            <Menu.Item
                                              onPress={() => {
                                                changeColor("Settings");
                                                navigation.navigate("Settings");
                                              }}
                                            >
                                              <Text color={GlobalStyles.colors.blue}>Settings</Text>
                                            </Menu.Item>
                                            <Menu.Item
                                              onPress={() => {
                                                setModalVisible(!modalVisible);
                                              }}
                                            >
                                              <Text color={GlobalStyles.colors.blue}>Contact Us</Text>
                                            </Menu.Item>
                                            <Menu.Item
                                              onPress={() => {
                                                dispatch(SetUser.action(null));
                                                navigation.navigate("Home");
                                              }}
                                            >
                                              <Text color={GlobalStyles.colors.blue}>Logout</Text>
                                            </Menu.Item>
                                          </Menu>
                                        </>
                                      )}
                                    </Stack>
                                  </Center>
                                </HStack>
                                <Divider bg={GlobalStyles.colors.mustard} w="100%" />
                              </Center>
                          </>
                        ) : (
                          <>
                          <StatusBar bg="#3700B3" barStyle="light-content" />
                              <Center>
                                <Box safeAreaTop bg="white" />
                                <HStack
                                  bg="muted.100"
                                  px="1"
                                  py="3"
                                  justifyContent="space-between"
                                  alignItems="center"
                                  w="100%"
                                  // maxW="900"
                                >
                                  <Center w={[150, 150, 300]}>
                                    <Pressable
                                      onPress={() => {
                                        // window.location.reload();
                                        navigation.navigate("Home");
                                      }}
                                    >
                                      <HStack alignItems="center">
                                        <Image
                                          source={require("../../assets/tt_logo.png")}
                                          alt="Alternate Text"
                                          size="xs"
                                        />
                                        {window?.innerWidth > 780 ? (
                                          <>
                                            <Text style={styles.textWithShadow}>TownTicks</Text>
                                          </>
                                        ) : (
                                          <>
                                            <Text style={styles.textWithShadowMobile}>TownTicks</Text>  
                                          </>
                                        )}
                                      </HStack>
                                    </Pressable>
                                  </Center>
                                  <Center w={[75, 350, 600]}>
                                    <Stack
                                      flexDirection={window?.innerWidth < 415 ? "column" : "row"}
                                      justifyContent="center"
                                    >
                                      {!user ? (
                                        <Button
                                          onPress={() => {
                                            changeColor("WhyTownTicks");
                                            navigation.navigate("WhyTownTicks");
                                          }}
                                          colorScheme="primary"
                                          size="md"
                                          variant="link"
                                        >
                                          <Text
                                            w={[75, 150, 150]}
                                            color={whyTownTicksColor}
                                            fontFamily={GlobalStyles.text.fontFamily}
                                            fontSize={"lg"}
                                            fontWeight="bold"
                                          >
                                            Why TownTicks?
                                          </Text>
                                        </Button>
                                      ) : (
                                        <>
                                        <VStack
                                            bg="#F5F5F5"
                                            px="1"
                                            py="3"
                                            justifyContent="space-between"
                                            alignItems="center"
                                            w="100%"
                                            // maxW="900"
                                          >
                                            {/* <Stack
                                              alignItems="center"
                                              flexDirection={window?.innerWidth < 415 ? "column" : "row"}
                                            > */}
                                             
                                              
                                            {/* </Stack> */}
                                        </VStack>
                                        </>
                                      )}
                                    </Stack>
                                  </Center>

                                  {/* for header icons */}

                                  
                                  <Center w={[75, 150, 300]}>
                                    <Stack
                                      flexDirection={window?.innerWidth < 415 ? "column" : "row"}
                                      justifyContent="center"
                                      mx={10}
                                    >
                                      {!user ? (
                                        <>
                                            <Button
                                            size="sm"
                                            variant={"solid"}
                                            px="3"
                                            bg={signInGuestColor}
                                            borderColor={signInGuestTextColor}
                                            borderWidth={2}
                                            onPress={() => {
                                              changeColor("SignInGuest");
                                              navigation.navigate("SignInGuest");
                                            }}
                                          >
                                            <Text fontWeight="bold" color={signInGuestTextColor}>
                                              Guest
                                            </Text>
                                          </Button>
                                          {/* <Button
                                            size="sm"
                                            variant={"solid"}
                                            px="3"
                                            bg={GlobalStyles.colors.blue}
                                            borderColor={GlobalStyles.colors.white}
                                            borderWidth={2}
                                            onPress={() => {
                                              setModalVisible(!modalVisible);
                                            }}
                                          >
                                            <Text fontWeight="bold" color={GlobalStyles.colors.white}>
                                              Contact Us
                                            </Text>
                                          </Button> */}
                                          <Button
                                            size="sm"
                                            variant={"solid"}
                                            px="3"
                                            bg={signUpColor}
                                            borderColor={signUpTextColor}
                                            borderWidth={2}
                                            onPress={() => {
                                              changeColor("SignUp");
                                              navigation.navigate("SignUp");
                                            }}
                                          >
                                            <Text fontWeight="bold" color={signUpTextColor}>
                                              Sign Up
                                            </Text>
                                          </Button>
                                          <Button
                                            size="sm"
                                            variant={"solid"}
                                            px="3"
                                            bg={signInColor}
                                            borderColor={signInTextColor}
                                            borderWidth={2}
                                            onPress={() => {
                                              changeColor("SignIn");
                                              navigation.navigate("SignIn");
                                            }}
                                          >
                                            <Text fontWeight="bold" color={signInTextColor}>
                                              Sign In
                                            </Text>
                                          </Button>
                                        </>
                                      ) : (
                                        <>
                                          <Menu
                                            w="190"
                                            placement={"bottom right"}
                                            trigger={(triggerProps) => {
                                              return (
                                                <Pressable
                                                  accessibilityLabel="More options menu"
                                                  {...triggerProps}
                                                >
                                                  <Image source={require("../../assets/side-bar-icons/gg_menu-grid-r.png")} alt="card-icon" size="40px"/>
                                                  {/* <HamburgerIcon size="md" mt={2} /> */}
                                                  {/* <Avatar
                                                    size="sm"
                                                    source={{
                                                      uri: GlobalConstants.notFoundImageUrl,
                                                    }}
                                                    bg={GlobalStyles.colors.blue}
                                                  >
                                                    {getAvatarChar(user.email)}
                                                  </Avatar> */}
                                                </Pressable>
                                              );
                                            }}
                                          >
                                            <Menu.Item isDisabled>
                                              <Text
                                                fontWeight="bold"
                                                fontFamily={GlobalStyles.text.fontFamily}
                                                color={GlobalStyles.colors.blue}
                                              >
                                                {user.profile ? user.profile.name : user.email}
                                              </Text>
                                            </Menu.Item>
                                            <Menu.Item
                                              onPress={() => {
                                                changeColor("Settings");
                                                navigation.navigate("Settings");
                                              }}
                                            >
                                              <Text color={GlobalStyles.colors.blue}>Settings</Text>
                                            </Menu.Item>
                                            <Menu.Item
                                              onPress={() => {
                                                setModalVisible(!modalVisible);
                                              }}
                                            >
                                              <Text color={GlobalStyles.colors.blue}>Contact Us</Text>
                                            </Menu.Item>
                                            <Menu.Item
                                              onPress={() => {
                                                dispatch(SetUser.action(null));
                                                navigation.navigate("Home");
                                              }}
                                            >
                                              <Text color={GlobalStyles.colors.blue}>Logout</Text>
                                            </Menu.Item>
                                          </Menu>
                                        </>
                                      )}
                                    </Stack>
                                  </Center>
                                </HStack>
                                <Divider bg={GlobalStyles.colors.mustard} w="100%" />
                              </Center>
                          </>
                        )}

              
            </>
          ):(
            <Center>
            <HStack bg="#F5F5F5" alignItems="center" w="100%" maxW="900">
              <Button
                alignSelf={"start"}
                size="sm"
                variant="link"
                onPress={() => {
                  navigation.navigate("Home");
                }}
              >
                Go to Home Page
              </Button>
            </HStack>
          </Center>
          )}
      

      <Center>
        <Box safeAreaTop bg="white" />
        <HStack
          bg="#F5F5F5"
          px="1"
          py="5"
          justifyContent="space-between"
          alignItems="center"
          w="100%"
          // maxW="900"
        >
          {user &&
          user.user_category == GlobalConstants.userCategories.citizen.id ? (
            <CitizenSettingsPage />
          ) : user &&
            user.user_category == GlobalConstants.userCategories.business.id ? (
            <BusinessSettingsPage />
          ) : user &&
            user.user_category ==
              GlobalConstants.userCategories.cityGovernment.id ? (
            <CityGovSettingsPage />
          ) : user &&
            user.user_category ==
              GlobalConstants.userCategories.chamberOfCommerce.id ? (
            <ChamberOfCommerceSettingsPage />
          ) : user &&
            user.user_category ==
              GlobalConstants.userCategories.advertiser.id ? (
            <AdvertiserSettingsPage />
          ) : user &&
            user.user_category ==
              GlobalConstants.userCategories.eventOrganizer.id ? (
            <EventSettingsPage />
          ) : (
            <>
              <ScrollView>
                <Center>
                  <Text mt={10}>No Settings</Text>
                </Center>
              </ScrollView>
            </>
          )}
        </HStack>
      </Center>
      
      <ConfigureSettingsPopup
        heading="Complete Profile"
        body="You are in settings. 'Click Go to Home' to go to the main page to see ticks."
        data={session.is_new_user}
        onChange={handleChange}
      />
       <Modal
        isOpen={modalVisible}
        onClose={() => setModalVisible(false)}
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
      >
        <Modal.Content>
          <Modal.CloseButton />
          <Modal.Header>Contact Us</Modal.Header>
          <Modal.Body>
            <Text>
              To contact or any feedback about TownTicks, write to
              <Text color={GlobalStyles.colors.blue}>
                {" "}
                support.townticks@novelma.com
              </Text>
            </Text>
          </Modal.Body>
          <Modal.Footer>
            <Button.Group space={2}>
              <Button
                variant="ghost"
                colorScheme="blueGray"
                onPress={() => {
                  setModalVisible(false);
                }}
              >
                Close
              </Button>
            </Button.Group>
          </Modal.Footer>
        </Modal.Content>
      </Modal>
    </>
  );
}

export default Settings;
